import { render } from "./DashboardSatu.vue?vue&type=template&id=0046b278"
import script from "./DashboardSatu.vue?vue&type=script&lang=js"
export * from "./DashboardSatu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__